import {
    trackPopupGa,
    getLocalStorage,
    setLocalStorage,
    isPc,
} from '@efe-activity-fe-util/core'
import {
    ALL_GP_SELECTOR,
    ALL_IOS_SELECTOR,
    SHOP_PRE_SUCCESS_POPUP_SELECTOR,
    ROLE_POPUP_HOST_SELECTOR,
    SHOP_PRE_POPUP_SELECTOR,
} from '../constants/selector'
import Config from '../libs/config.json'
import { usePopup } from '../hooks/usePopup'

const { gameCode, activityCode } = Config
const preStatusKey = `${gameCode}_${activityCode}_pre_status`

const { openPopup, closePopupAll } = usePopup()

export async function bootstrap() {
    bindEvent()
}

export function getPreStatus() {
    return !!getLocalStorage(preStatusKey)
}

export function setPreStatus() {
    setLocalStorage(preStatusKey, 1)
}

function bindEvent() {
    // scrollOpenPopup(ROLE_POPUP_HOST_SELECTOR)
    // $(`${ALL_GP_SELECTOR}, ${ALL_IOS_SELECTOR}`).on('click', () => {
    //     closePopupAll()
    //     if (!getPreStatus()) {
    //         trackPopupGa(SHOP_PRE_SUCCESS_POPUP_SELECTOR)
    //     }
    //     setPreStatus()
    //     // window.openPreSuccessPopup = true
    //     // closePopupAll()
    //     // trackPopupGa(PRE_SUCCESS_POPUP_SELECTOR, PRE_SUCCESS_POPUP_SELECTOR, {
    //     //     onClose: () => {
    //     //         window?.popupCloseHandler?.()
    //     //         window.openPreSuccessPopup = false
    //     //     },
    //     // })
    // })
}

function scrollOpenPopup(selector: string) {
    if (getPreStatus()) {
        return
    }

    const el = document.querySelector(selector)

    if (!el) {
        return
    }

    let last = 0
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (getPreStatus() || last > 0) {
                observer.disconnect()
                return
            }

            const now = Date.now()

            if (!entry.isIntersecting || now - last < 0) {
                return
            }

            closePopupAll()
            openPopup(SHOP_PRE_POPUP_SELECTOR)
            last = now
        },
        { threshold: 0.5 }
    )
    observer.observe(el)
}
